import { render, staticRenderFns } from "./department-list.vue?vue&type=template&id=6360b57e&scoped=true"
import script from "./department-list.vue?vue&type=script&lang=js"
export * from "./department-list.vue?vue&type=script&lang=js"
import style0 from "./department-list.vue?vue&type=style&index=0&id=6360b57e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6360b57e",
  null
  
)

export default component.exports